import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FaAngleRight } from 'react-icons/fa6'
import { useLocation } from "react-router-dom";

export default function Breadcrum({ items }) {
    const location = useLocation();
    let homeURL = "/";
    if(location.pathname.split('/')[1] === 'super-admin') {
        homeURL = "/super-admin/dashboard";
    }else if(location.pathname.split('/')[1] === 'admin') {
        homeURL = "/admin/dashboard";
    }else if(location.pathname.split('/')[1] === 'employee') {
        homeURL = "/employee/dashboard";
    }

  if (!items || items.length === 0) return null

  return (
    <div className="breadcrumb-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb flex items-center justify-start gap-2 ">
          <li className="breadcrumb-item">
            <Link to={homeURL} className="flex items-center">
              Home
            </Link>
          </li>
          {items.map((item, index) => {
            const isLast = index === items.length - 1

            return (
              <React.Fragment key={index}>
                <FaAngleRight 
                  className="text-gray-400 mt-1" 
                />
                <li
                  className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                  {...(isLast && { 'aria-current': 'page' })}
                >
                  {isLast ? (
                    item.label
                  ) : (
                    <Link  to={item.path}>{item.label}</Link>
                  )}
                </li>
              </React.Fragment>
            )
          })}
        </ol>
      </nav>
    </div>
  )
}

Breadcrum.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  ).isRequired
}
